import { useNavigate } from "react-router-dom";
import "./LiveReplayListSection.less";

interface LiveReplayItem {
  id: string;
  thumbnail: string;
  date: string;
  time: string;
}

interface LiveReplayListSectionProps {
  title: string;
  items: LiveReplayItem[];
}

const LiveReplayListSection: React.FC<LiveReplayListSectionProps> = ({ title, items }) => {
  const navigate = useNavigate();

  const handleItemClick = (replayId: string, thumbnail: string) => {
    navigate(`/common/live-replays/${replayId}`, { state: { thumbnail } });
  };

  return (
    <div className="live-replay-list-section">
      <h2 className="section-title">{title}</h2>
      <div className="replay-list-container">
        {items.map((item) => (
          <div key={item.id} className="replay-item" onClick={() => handleItemClick(item.id, item.thumbnail)}>
            <div className="replay-thumbnail" style={{ backgroundImage: `url(${item.thumbnail})` }}>
              <div className="replay-date-container">
                <span className="replay-date-time">
                  {item.date} à {item.time}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LiveReplayListSection;
